/* Is there a connection, and has it just come back?
 *
 * `navigator.onLine` is famously optimistic -- it says true for a laptop on
 * a wifi network with no route out -- so it is treated as a hint rather than
 * the truth. What the app actually reacts to is a request failing with a
 * network error; this hook is how the *banner* knows, and how a return to
 * the office triggers a flush.
 */
import { useEffect, useState } from 'react'

export function useOnline(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine)

  useEffect(() => {
    const up = () => setOnline(true)
    const down = () => setOnline(false)
    window.addEventListener('online', up)
    window.addEventListener('offline', down)
    return () => {
      window.removeEventListener('online', up)
      window.removeEventListener('offline', down)
    }
  }, [])

  return online
}
